import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const reasons = [
    'Feito por quem vive a impressão 3D — Os fluxos são pensados para uma operação real, considerando impressoras, materiais, produção, falhas, custos e margens — e não apenas a lógica de um varejo genérico ou cenários hipotéticos.',
    'Menos lançamento manual. Mais informação da operação — Com a integração às impressoras*, os dados de produção são registrados automaticamente, reduzindo a dependência de lançamentos manuais. E o melhor de tudo, não limitamos a conexão apenas à Bambu Lab. O Acompanha 3D é o único sistema de gestão que conecta com Bambu Lab, Creality, Anycubic, Flashforge e muitas outras.',
    'E o sistema continua evoluindo — O desenvolvimento é guiado pelo uso real e pelas necessidades que surgem no dia a dia. Feedback, sugestões e críticas são sempre muito bem-vindos.',
];

const WhyUs = () => (
    <Box id="mais-motivos" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surfaceAlt }}>
        <Box sx={publicContainerSx}>
            <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={5}>
                    <Typography component="h2" sx={publicH2Sx}>
                        Por que não uma planilha?
                    </Typography>
                    <Typography sx={{ ...publicSubtitleSx, mx: 0, textAlign: 'left' }}>
                        Porque numa planilha você registra o que <strong>já aconteceu</strong>. O Acompanha 3D ajuda 
                        você a entender o que <strong>está acontecendo</strong> na sua operação e tomar decisões com base em dados reais.

                    <br />
                    <br />
                    Qual impressora mais falha? Quais produtos realmente geram margem? Quanto sua farm custa para produzir? Onde estão acontecendo perdas, retrabalho e desperdícios? E como isso afeta seu lucro? Essas são as perguntas que o Acompanha 3D responde.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Stack spacing={2}>
                        {reasons.map((text) => (
                            <Stack key={text} direction="row" spacing={1.5} alignItems="flex-start">
                                <CheckCircleOutlineIcon sx={{ color: publicColors.accent, mt: 0.25, flexShrink: 0 }} />
                                <Typography sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>{text}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    </Box>
);

export default WhyUs;
